"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCardAuto = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var modalSlice_1 = require("../redux/slice/modalSlice");
var selectors_1 = require("../redux/selectors");
var useCardAuto = function (_a) {
    var car = _a.car, inModalSelect = _a.inModalSelect;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = react_1.default.useState(0), currentImageIndex = _b[0], setCurrentImageIndex = _b[1];
    var selectedCarId = Number((0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.car.carSelect.unique_id);
    var isSelected = selectedCarId === car.unique_id;
    var handlers = react_1.default.useMemo(function () { return ({
        handleMouseMove: function (index) {
            setCurrentImageIndex(index);
        },
        handleCardClick: function () {
            if (!inModalSelect)
                return;
            dispatch((0, modalSlice_1.setSelectCar)(car));
            dispatch((0, modalSlice_1.closeModal)('selectCar'));
        },
        handleImageClick: function () {
            if (!inModalSelect) {
                var encodedBrand = encodeURIComponent(typeof car.brand === 'string' ? car.brand : car.brand.name);
                navigate("/car/".concat(encodedBrand, "/").concat(car.unique_id), {
                    state: { car: car },
                });
            }
        },
        handleCreditButtonClick: function () {
            dispatch((0, modalSlice_1.setSelectCar)(car));
            dispatch((0, modalSlice_1.openModal)('credit'));
        },
    }); }, [dispatch, navigate, car, inModalSelect]);
    return {
        currentImageIndex: currentImageIndex,
        isSelected: isSelected,
        handlers: handlers,
    };
};
exports.useCardAuto = useCardAuto;
